export {default as BeWizrCourseDocument} from './BeWizrCourseDocument'
export {default as BeWizrCourseItemDocument} from './BeWizrCourseItemDocument'
export {default as BeWizrCourseItemsEndpoint} from './BeWizrCourseItemsEndpoint'
export {default as BeWizrCoursesEndpoint} from './BeWizrCoursesEndpoint'